export default {
    totalItems: state => state.totalItems,
    inschrijvers: state => state.inschrijvers,
    rowsPerPage: state => state.pagination.rowsPerPage,
    pagination: state => state.pagination
}
